import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  SimpleGrid,
  useColorModeValue
} from "@chakra-ui/react";
import { PessoaType } from "models/person_type";
import FormClient from "views/admin/clients/components/Form";
import useClients from "views/admin/clients/hooks/useClients";
import LaunchProjectForm from "./components/Form";
import LaunchedOrderTable from "./components/Table";
import useLaunchProject from "./hooks/useLaunchProject";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const ProjectLaunchScreen = () => {
  const {
    list1,
    showModal1,
    selectedOrder1,
    show1,
    clients,
    loading,
    descricao,
    changeInput,
    users,
    cidades,
    insertCity,
    changeCity,
    addCity,
    removeCity,
    editCity,
    contatoAgencia1,
    contatoCliente1,
    contatoList1,
    addContact,
    changeContact,
    editContact,
    insertContact,
    removeContact,
    cityRef,
    contactRef,
    chageTipo,
    addUser,
    usuarios,
    changeRespFinanceiro,
    changeRespJuridico,
    error,
    errorMsg,
    errorTitle,
    cancelRef,
    closeError,
    showError,
    save,
    reloadDataClients,
    changeContrato,
    changeFaturamento,
    faturamento,
    contrato
  } = useLaunchProject();

  const {
    enderecoList, showFormPessoa, adicionarContato, adicionarEndereco, bairroRef,
    cargoContatoRef, cepRef, changeFilial, changeItemPessoa, cidadeRef, classificacaoList, classificacaoRef, client,
    complementoRef, contatoList, contribuinteRef, deleteContato, showPessoa, idTipoRef, documentoRef, razaoSocialRef,
    nomeFantasiaRef, inscricaoMunicipalRef, inscricaoEstadualRef, tipoPessoaList, ruaRef, numeroRef, estadoRef, principalRef,
    loadCEP, viaCepEnd, deleteEnd, emailContatoRef, principalContatoRef, nomeContatoRef, filial, telefoneContatoRef, pessoaFilial,
    nomeClinteRef, editPessoa, saveCliente,
    contaList,
    bancoRef,
    agenciaRef,
    tipoRef,
    numeroContaRef,
    titularRef,
    tipoPessoaRef,
    documentoContaRef,
    descricaoRef,
    obsRef,
    deleteConta,
    adcionarConta


  } = useClients();
  const editarPessoa = (item: PessoaType) => {
    if (item === undefined || item === null) {
      showError('Erro!', 'Selecione o Cliente/Agência para editar seus dados!')
    } else {
      editPessoa(item);
    }
  }

  const savePersonData = async () => {
    await saveCliente();
    await reloadDataClients();
  }

  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  return (

    <Box pt={{ base: "130px", md: "80px", xl: "80px" }} overflowY={"scroll"}>
      <ConditionalRenderer
        conditions={[
          {
            condition: show1,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal1(false, null)}
                title="Lançamento do Projeto"
              >
                <LaunchProjectForm
                  accountSelected={selectedOrder1}
                  show={show1}
                  showModal={showModal1}
                  clients={clients}
                  loading={loading}
                  descricao={descricao}
                  changeInput={changeInput}
                  users={users}
                  cidades={cidades}
                  insertCity={insertCity}
                  changeCity={changeCity}
                  addCity={addCity}
                  removeCity={removeCity}
                  editCity={editCity}
                  contatoAgencia={contatoAgencia1}
                  contatoCliente={contatoCliente1}
                  contatoList={contatoList1}
                  addContact={addContact}
                  changeContact={changeContact}
                  editContact={editContact}
                  insertContact={insertContact}
                  removeContact={removeContact}
                  cityRef={cityRef}
                  contactRef={contactRef}
                  chageTipo={chageTipo}
                  addUser={addUser}
                  usuarios={usuarios}
                  changeRespFinanceiro={changeRespFinanceiro}
                  changeRespJuridico={changeRespJuridico}
                  save={save}
                  editPessoa={editarPessoa}
                  showFormPessoa={showFormPessoa}
                  changeContrato={changeContrato}
                  changeFaturamento={changeFaturamento}
                  contrato={contrato}
                  faturamento={faturamento}
                />
              </SimpleConditionalFrame>
            )
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <LaunchedOrderTable list={list1} showModal={showModal1} />
          </SimpleGrid>
        )}
      />
      <FormClient
        enderecoList={enderecoList}
        accountSelected={client}
        brandStars={brandStars}
        error={error}
        loading={loading}
        save={savePersonData}
        nomeRef={nomeClinteRef}
        show={showPessoa}
        showModal={showFormPessoa}
        textColor={textColor}
        idTipoRef={idTipoRef}
        classificacaoRef={classificacaoRef}
        documentoRef={documentoRef}
        razaoSocialRef={razaoSocialRef}
        nomeFantasiaRef={nomeFantasiaRef}
        inscricaoMunicipalRef={inscricaoMunicipalRef}
        inscricaoEstadualRef={inscricaoEstadualRef}
        contribuinteRef={contribuinteRef}
        classificacaoList={classificacaoList}
        tipoPessoaList={tipoPessoaList}
        bairroRef={bairroRef}
        cepRef={cepRef}
        ruaRef={ruaRef}
        numeroRef={numeroRef}
        complementoRef={complementoRef}
        cidadeRef={cidadeRef}
        estadoRef={estadoRef}
        principalRef={principalRef}
        loadCEP={loadCEP}
        viaCepEnd={viaCepEnd}
        adicionarEnd={adicionarEndereco}
        deleteEnd={deleteEnd}
        contatoList={contatoList}
        deleteContato={deleteContato}
        adicionarContato={adicionarContato}
        cargoContatoRef={cargoContatoRef}
        emailContatoRef={emailContatoRef}
        nomeContatoRef={nomeContatoRef}
        principalContatoRef={principalContatoRef}
        telefoneContatoRef={telefoneContatoRef}
        changeItem={changeItemPessoa}
        filial={filial}
        changeFilial={changeFilial}
        pessoaFilial={pessoaFilial}
        adcionarConta={adcionarConta}
        agenciaRef={agenciaRef}
        bancoRef={bancoRef}
        contaList={contaList}
        deleteConta={deleteConta}
        descricaoRef={descricaoRef}
        documentoContaRef={documentoContaRef}
        numeroContaRef={numeroContaRef}
        obsRef={obsRef}
        tipoPessoaRef={tipoPessoaRef}
        tipoRef={tipoRef}
        titularRef={titularRef}

      />

      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={closeError}
                colorScheme={"blue"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};
export default ProjectLaunchScreen;
